<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>General
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Column relative
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.settings.relative"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Column styling reset
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.settings.reset"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Default width
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Width
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.width.options" v-model="element.object.settings.responsive.default.width" />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Visible
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="fields.visible"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Small
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Width
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.small.width.options" v-model="element.object.settings.responsive.sm.width" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Visible
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="fields.small.visible"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Medium
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Width
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.medium.width.options" v-model="element.object.settings.responsive.md.width" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Visible
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="fields.medium.visible"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Large
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Width
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.large.width.options" v-model="element.object.settings.responsive.lg.width" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Visible
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="fields.large.visible"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Extra Large
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Width
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.xlarge.width.options" v-model="element.object.settings.responsive.xl.width" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Visible
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="fields.xlarge.visible"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Other
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Flexbox
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-toggle
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="fields.flexbox"
                        />
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';
    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import FieldText from '@/components/fields/inputs/Text';
    import FieldSelect from '@/components/fields/inputs/Select';
    import FieldToggle from '@/components/fields/inputs/Toggle';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-select': FieldSelect,
            'app-field-text': FieldText,
            'app-field-toggle': FieldToggle
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            fields: {
                relative: {
                    name: 'Column relative',
                    attribute: 'relative'
                },
                reset: {
                    name: 'Container reset',
                    attribute: 'reset'
                },
                flexbox: {
                    name: 'Flexbox',
                    attribute: 'flexbox'
                },
                small: {
                    visible: {
                        name: 'Visible',
                        attribute: 'smallVisible'
                    },
                    width: {
                        name: 'Width',
                        attribute: 'smallWidth',
                        options: [
                            { value: 'w-full', label: 'Full width' },
                            { value: 'w-1/2', label: '1/2 - 50%'  },
                            { value: 'w-1/4', label: '1/4 - 25%' },
                            { value: 'w-3/4', label: '3/4 - 75%' },
                            { value: 'w-1/3', label: '1/3 - 33%' },
                            { value: 'w-2/3', label: '2/3 - 66%' },
                            { value: 'w-1/5', label: '1/5 - 20%' },
                            { value: 'w-2/5', label: '2/5 - 40%' },
                            { value: 'w-3/5', label: '3/5 - 60%' },
                            { value: 'w-4/5', label: '4/5 - 80%' },
                            { value: 'w-1/6', label: '1/6 - 16%' },
                            { value: 'w-5/6', label: '5/6 - 83%' }
                        ]
                    }
                },
                medium: {
                    visible: {
                        name: 'Visible',
                        attribute: 'mediumVisible'
                    },
                    width: {
                        name: 'Width',
                        attribute: 'mediumWidth',
                        options: [
                            { value: 'w-full', label: 'Full width' },
                            { value: 'w-1/2', label: '1/2 - 50%'  },
                            { value: 'w-1/4', label: '1/4 - 25%' },
                            { value: 'w-3/4', label: '3/4 - 75%' },
                            { value: 'w-1/3', label: '1/3 - 33%' },
                            { value: 'w-2/3', label: '2/3 - 66%' },
                            { value: 'w-1/5', label: '1/5 - 20%' },
                            { value: 'w-2/5', label: '2/5 - 40%' },
                            { value: 'w-3/5', label: '3/5 - 60%' },
                            { value: 'w-4/5', label: '4/5 - 80%' },
                            { value: 'w-1/6', label: '1/6 - 16%' },
                            { value: 'w-5/6', label: '5/6 - 83%' }
                        ]
                    }
                },
                large: {
                    visible: {
                        name: 'Visible',
                        attribute: 'largeVisible'
                    },
                    width: {
                        name: 'Width',
                        attribute: 'largeWidth',
                        options: [
                            { value: 'w-full', label: 'Full width' },
                            { value: 'w-1/2', label: '1/2 - 50%'  },
                            { value: 'w-1/4', label: '1/4 - 25%' },
                            { value: 'w-3/4', label: '3/4 - 75%' },
                            { value: 'w-1/3', label: '1/3 - 33%' },
                            { value: 'w-2/3', label: '2/3 - 66%' },
                            { value: 'w-1/5', label: '1/5 - 20%' },
                            { value: 'w-2/5', label: '2/5 - 40%' },
                            { value: 'w-3/5', label: '3/5 - 60%' },
                            { value: 'w-4/5', label: '4/5 - 80%' },
                            { value: 'w-1/6', label: '1/6 - 16%' },
                            { value: 'w-5/6', label: '5/6 - 83%' }
                        ]
                    }
                },
                xlarge: {
                    visible: {
                        name: 'Visible',
                        attribute: 'xlargeVisible'
                    },
                    width: {
                        name: 'Width',
                        attribute: 'xlargeWidth',
                        options: [
                            { value: 'w-full', label: 'Full width' },
                            { value: 'w-1/2', label: '1/2 - 50%'  },
                            { value: 'w-1/4', label: '1/4 - 25%' },
                            { value: 'w-3/4', label: '3/4 - 75%' },
                            { value: 'w-1/3', label: '1/3 - 33%' },
                            { value: 'w-2/3', label: '2/3 - 66%' },
                            { value: 'w-1/5', label: '1/5 - 20%' },
                            { value: 'w-2/5', label: '2/5 - 40%' },
                            { value: 'w-3/5', label: '3/5 - 60%' },
                            { value: 'w-4/5', label: '4/5 - 80%' },
                            { value: 'w-1/6', label: '1/6 - 16%' },
                            { value: 'w-5/6', label: '5/6 - 83%' }
                        ]
                    }
                },
                width: {
                    name: 'Width (mobile)',
                    attribute: 'width',
                    options: [
                        { value: 'w-full', label: 'Full width' },
                        { value: 'w-1/2', label: '1/2 - 50%'  },
                        { value: 'w-1/4', label: '1/4 - 25%' },
                        { value: 'w-3/4', label: '3/4 - 75%' },
                        { value: 'w-1/3', label: '1/3 - 33%' },
                        { value: 'w-2/3', label: '2/3 - 66%' },
                        { value: 'w-1/5', label: '1/5 - 20%' },
                        { value: 'w-2/5', label: '2/5 - 40%' },
                        { value: 'w-3/5', label: '3/5 - 60%' },
                        { value: 'w-4/5', label: '4/5 - 80%' },
                        { value: 'w-1/6', label: '1/6 - 16%' },
                        { value: 'w-5/6', label: '5/6 - 83%' }
                    ]
                },
                visible: {
                    name: 'Visible',
                    attribute: 'visible'
                },
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Forms/Column.vue